import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { z } from "zod";

import { rootRoute } from "../../router/rootRoutes";

const authSearchSchema = z.object({
  invite: z
    .string()
    .regex(/^[A-Za-z0-9_-]{32,128}$/u)
    .optional()
    .catch(undefined),
});

export const authRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/auth",
  validateSearch: authSearchSchema,
  component: lazyRouteComponent(() => import("./AuthPage"), "AuthPage"),
});
